
const FloatingButtons = function () {

  function init() {

    const layoutBuilderMode = document.getElementById('layout-builder')
    const content = document.getElementById('main-content')
    const anchorFaqs = document.getElementById('faqs-with-floating-button')
    const contactSection = document.getElementById('contactSection')

    if (content && !layoutBuilderMode) {
      if (contactSection) {
        const floatingButtonContact = document.createElement('a');
        if (anchorFaqs) {
          floatingButtonContact.className = 'floating-button second';
        } else {
          floatingButtonContact.className = 'floating-button';
        }
        floatingButtonContact.setAttribute('href', '#contactSection');

        const buttonImageContact = document.createElement('img');
        buttonImageContact.setAttribute('alt', 'Button to contact form');
        buttonImageContact.setAttribute('src', '/themes/custom/dehn21/img/icons/contact.svg');

        floatingButtonContact.appendChild(buttonImageContact)
        content.append(floatingButtonContact)
      }
      if (anchorFaqs) {
        const floatingButtonFAQs = document.createElement('a');
        floatingButtonFAQs.className = 'floating-button';
        floatingButtonFAQs.setAttribute('href', '#faqs-with-floating-button');

        const buttonImageFAQs = document.createElement('img');
        buttonImageFAQs.setAttribute('alt', 'Button to FAQ');
        buttonImageFAQs.setAttribute('src', '/themes/custom/dehn21/img/icons/faq.svg');

        floatingButtonFAQs.appendChild(buttonImageFAQs)
        content.append(floatingButtonFAQs)
      }
    }
  }

  return {
    init
  }

}()

export default FloatingButtons
